import endpoint from "../../config/endpoints";

export const companyTargetJson = {
  formPath: "/company-and-target-form",
  apiBaseURL: endpoint.companyTarget,
  screenTitle: "Company Target",
  showAddButton: true,
  showPdfDownload: false,
  pdfFileName: "Company Target",
  showExcelDownload: false,
  excelFileName: "Company Target",
  formPathView: "/company-and-target-view",

  tableColumnsToFilter: [
    {
      columnDisplayName: "Year",
      columnKeyName: "name",
      isChecked: true,
    },
    {
      columnDisplayName: "Jan",
      columnKeyName: "jan",
      isChecked: true,
    },
    {
      columnDisplayName: "Feb",
      columnKeyName: "feb",
      isChecked: true,
    },
    {
      columnDisplayName: "March",
      columnKeyName: "march",
      isChecked: true,
    },
    {
      columnDisplayName: "April",
      columnKeyName: "april",
      isChecked: true,
    },
    {
      columnDisplayName: "May",
      columnKeyName: "may",
      isChecked: true,
    },

    {
      columnDisplayName: "Jun",
      columnKeyName: "jun",
      isChecked: true,
    },
    {
      columnDisplayName: "July",
      columnKeyName: "july",
      isChecked: true,
    },
    {
      columnDisplayName: "Aug",
      columnKeyName: "aug",
      isChecked: true,
    },
    {
      columnDisplayName: "Sep",
      columnKeyName: "sep",
      isChecked: true,
    },
    {
      columnDisplayName: "Oct",
      columnKeyName: "oct",
      isChecked: true,
    },
    {
      columnDisplayName: "Nov",
      columnKeyName: "nov",
      isChecked: true,
    },
    {
      columnDisplayName: "Dec",
      columnKeyName: "dec",
      isChecked: true,
    },
    {
      columnDisplayName: "Total",
      columnKeyName: "total",
      isChecked: true,
    },
  ],

  fieldMeta: [
    {
      label: "Year",
      controlType: "autocomplete",
      placeHolder: "Year",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "yearDetail",
      dataKey: "yearName",
      getListId: "yearName",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Denomination",
      controlType: "radiogroup",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "type",
      tableDataKey: "type",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "K",
          value: "0",
        },
        {
          label: "L",
          value: "1",
        },
        {
          label: "CR",
          value: "2",
        },
      ],
      isMandatory: true,
    },
  ],
};
